import FetchError from '../types/http';
import log from '../util/log';
import fetcher from '../util/fetcher';
import {
  GetMicroInteractionClientPageEnum,
  GetMicroInteractionClientPlatformTypeEnum,
  GetMicroInteractionRequest,
  MicroInteractionsApi,
} from '../api/generated-client/MicroInteraction-Service.v1/apis';
import { Configuration } from '../api/generated-client/MicroInteraction-Service.v1/runtime';

const config = new Configuration({
  fetchApi: fetcher,
  basePath: `/api/petprofile/`,
  middleware: [],
});

const mintApi = new MicroInteractionsApi(config);

const handleFetchError = (error: Error | FetchError, service: string = 'unknown'): FetchError => {
  log.error(`Error from fetch request, service: ${service}`, error.message);
  if ('status' in error) {
    return error;
  }
  return { ...error, status: 500 };
};

const handleMintError = (error: any, apiName: string) =>
  error.response ? handleFetchError(error.response, apiName) : handleFetchError(error, apiName);

const transformData = (data: any) => data;

export const getMintRequestParam = (
  mintId: number | null,
  clientPlatformVersion: string,
  clientPage: GetMicroInteractionClientPageEnum,
  clientPlatformType: GetMicroInteractionClientPlatformTypeEnum,
  petId: number | null, // use options instead
): GetMicroInteractionRequest => {
  let requestParams: GetMicroInteractionRequest = {
    clientPlatformVersion: clientPlatformVersion,
    clientPage: clientPage,
    clientPlatformType: clientPlatformType,
  };
  if (mintId) {
    requestParams.id = mintId;
  }
  if (petId) {
    requestParams.petId = petId;
  }
  return requestParams;
};

export const getMicroInteraction = ({
  queryKey: [, mintQueryParams],
}: {
  queryKey: [any, GetMicroInteractionRequest];
}) =>
  new Promise((resolve, reject) => {
    mintApi
      .getMicroInteraction(mintQueryParams, {
        cache: 'no-cache',
      })
      .then((data) => resolve(transformData(data)))
      .catch((error) => reject(handleMintError(error, 'getMicroInteraction')));
  });

const GET_MICROINTERACTION = 'GET_MICROINTERACTION';

getMicroInteraction.key = GET_MICROINTERACTION;
